var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { apiGetListCase } from '@/actions/CaseActions';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { SESSION_STORAGE_KEY_TOP_CASE_LIST } from '@/utils/constants/storage/sessionStorageKey';
import { useSessionStorage } from '@/utils/libs/react-hookz/useSessionStorage';
/**
 * 選定支援事例の情報を取得するカスタムフック
 */
export const useTopPageFetchCase = (options) => {
    const { dispatch } = options;
    // 選定支援一覧のデータを保存
    const { set: setCaseList, value: caseList } = useSessionStorage(SESSION_STORAGE_KEY_TOP_CASE_LIST, {
        defaultValue: undefined,
    });
    /**
     * 選定支援事例一覧情報取得
     */
    const fetchCase = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const { payload } = yield wrapDispatch(dispatch, apiGetListCase({ query: { is_top: 1, page: 1 } }, {}));
        // 取得したデータを sessionStorage に保存
        setCaseList(payload.list);
    }), [dispatch, setCaseList]);
    return {
        caseList,
        fetchCase,
    };
};
